import OrderableListItem from "./template";

export default OrderableListItem;